import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from 'src/shared/page-not-found/page-not-found.component';

const routes: Routes = [
  // { path: 'success', component: SuccessComponent },

  {
    path: 'auth',
    loadChildren: () => import('./feature/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'host',
    loadChildren: () => import('./feature/auth/screens/Host/auth.module').then(m => m.AuthModule),
  },

  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
